<template>
  <div class="select-role">
    <!--  -->
    <div class="select-header">
      <div class="pms-logo" />
      <div
        class="logout"
        @click="logout"
      >
        登出
      </div>
    </div>
    <div class="select-role-title">
      <h3>請選擇登入賬戶</h3>
      <h6>以下為你所在的組別和對應角色，點擊直接進入</h6>
    </div>
    <div class="organization-list">
      <div
        v-for="item in roleList"
        :key="item.accountDepartmentID"
        class="organization-item"
      >
        <div
          class="organization-name"
          :class="{ active: userInfo.departmentID === item.accountDepartmentID }"
          @click="choseRole(item.accountDepartmentID)"
        >
          <span class="text-container">{{ `${item.departmentName} — ${item.roleName}` }}</span>
        </div>
        <el-checkbox
          v-model="item.isDefault"
          :label="item.accountDepartmentID"
          @change="handleCheckedChange(item)"
        >
          預設登入賬戶
        </el-checkbox>
      </div>
    </div>
  </div>
</template>
<script>
// 节流函數
import { mapState, mapMutations } from 'vuex';
export default {
    name: 'SelectRole',
    data() {
        return {
            defaultDepartmentId: '', //默认角色id
            departmentId: '', // 进入页面的角色id
            isSwitch: false, // 判斷是登录之后还是未登录进入到该页面
            roleList: [], //角色列表
            path: '',
            timeId: ''
        };
    },
    created() {
        if (this.$route.query.sorcepath === 'login') {
            this.isSwitch = false;
            this.roleList = this.loginInfo.roleList;
        } else {
            this.isSwitch = true;
            this.getRoleList();
        }
    },
    computed: mapState(['loginInfo', 'userInfo']),
    methods: {
        ...mapMutations(['setLoginInfo', 'resetVuex']),
        handleCheckedChange(value) {
            console.log(value);
            let isDefault = this.roleList.forEach(item => {
                if (item.accountDepartmentID !== value.accountDepartmentID) {
                    item.isDefault = false;
                }
            });
            this.defaultDepartmentId = value.isDefault ? value.accountDepartmentID : '';
            this.setDeafaultDepartment();
        },
        async setDeafaultDepartment() {
            if (this.isSwitch) {
                let res = await this.axios.get(this.pub.getApi().SetDefaultDepartment, {
                    params: {
                        setDefaultDepartmentID: this.defaultDepartmentId || 0
                    }
                });
                // console.log(res);
                let { code, result, message } = res.data;
                if (code === 0) {
                    this.$message({
                        message: '设置成功',
                        type: 'success',
                        showClose: true
                    });
                } else {
                    this.$message({
                        message: message,
                        type: 'error',
                        showClose: true
                    });
                }
            }
        },
        // 進入選中角色頁面
        choseRole(value) {
            // 防抖函数 ---防止多次点击出问题
            if (this.timeId != null) {
                clearTimeout(this.timeId);
            }
            this.timeId = setTimeout(() => {
                this.departmentId = value;
                if (this.isSwitch) {
                    this.swithLogin();
                } else {
                    this.login({
                        accountID: this.loginInfo.accountID,
                        departmentID: this.departmentId,
                        password: this.loginInfo.password,
                        setDefaultDepartmentID: this.defaultDepartmentId
                    });
                }
            }, 500);
            this.$notify.closeAll();
            // 登录
            // console.log(this.isSwitch);
        },
        // 登录
        async login(data) {
            // console.log(data);
            let res = await this.axios.post(this.pub.getApi().Login, data);
            // console.log(res);
            let { code, result, message } = res.data;
            if (code === 0) {
                this.resetVuex();
                this.pub.setCookie('dEVaUDFrZ1kd0RA', result.token);
                // 重置login参数信息
                this.setLoginInfo({});
                // console.log(result);
                // 添加登陆标识
                localStorage.setItem('isLoginAgain', 1);
                localStorage.setItem('propertyListTipShow', true);
                this.$router.push('/');
                this.$message({
                    message: '登入成功',
                    type: 'success',
                    showClose: true
                });
            } else if (code === 1312) {
                this.$message({
                    message: '妳的賬戶已被停用，請聯絡客戶服務',
                    type: 'error',
                    showClose: true
                });
            } else {
                this.$message({
                    message: message,
                    type: 'error',
                    showClose: true
                });
            }
        },
        // 切換登錄
        async swithLogin() {
            let res = await this.axios.post(this.pub.getApi().SwithLogin, {
                departmentID: this.departmentId,
                setDefaultDepartmentID: this.defaultDepartmentId
            });
            // console.log(res);
            let { code, result, message } = res.data;
            if (code === 0) {
                // this.setUserInfo(result)
                this.pub.setCookie('dEVaUDFrZ1kd0RA', result.token);
                this.resetVuex();
                await this.pub.obtainAndSetUserInfo();
                await this.pub.obtainAndSetRoutes(result.currentRoleID);
                await this.pub.obtainAndSetPermissions(result.currentRoleID);
                this.$message({
                    message: '切換登入成功',
                    type: 'success',
                    showClose: true
                });
                localStorage.setItem('propertyListTipShow', true);
                // this.$router.push('/');
                // 修改 有时点击白屏
                this.$router.push('/homepage');                
            } else if (code === 1312) {
                this.$message({
                    message: '妳的賬戶已被停用，請聯絡客戶服務',
                    type: 'error',
                    showClose: true
                });
            } else {
                this.$message({
                    message: message,
                    type: 'error',
                    showClose: true
                });
            }
        },
        // 獲取角色列表
        async getRoleList() {
            let res = await this.axios.get(this.pub.getApi().RefeshToken);
            // console.log(res);
            let { code, result, message } = res.data;
            if (code === 0) {
                this.roleList = result.roleList;
                // console.log("rolelist", result.roleList);
                let isDefault = this.roleList.find(item => {
                    return item.isDefault;
                });
                if (isDefault) {
                    this.defaultDepartmentId = isDefault.accountDepartmentID;
                }
            }
        },
        logout() {
            this.$confirm('確認要登出本系統？', '登出', {
                confirmButtonText: '確認',
                cancelButtonText: '取消'
            })
                .then(() => {
                    this.$notify.closeAll();
                    this.pub.delCookie('dEVaUDFrZ1kd0RA');
                    this.resetVuex();
                    this.$router.push({ name: this.pub.routeNameLists.Login });
                })
                .catch(() => {});
        }
    }
    // beforeRouteEnter(to, from, next) {
    //   console.log();
    //   next(vm => {
    //     // 通过 `vm` 访问组件实例
    //     // console.log("vm", vm);
    //     vm.path = from.path;
    //   });
    // }
};
</script>
<style lang="less" scoped>
.select-role {
    width: 100%;
    height: 100%;
    min-height: 625px;
    background-color: #f3f3f5;
    overflow: auto;
    .select-header {
        width: 100%;
        height: 50px;
        background-color: #040637;
        position: fixed;
        top: 0;
        left: 0;
        .pms-logo {
            height: 30px;
            width: 121px;
            background: url(../assets/Logo_white.svg) center no-repeat;
            background-size: auto 100%;
            position: absolute;
            left: 23px;
            top: 10px;
            opacity: 0.6;
        }
        .logout {
            position: absolute;
            right: 20px;
            top: 0;
            height: 50px;
            line-height: 50px;
            color: #fff;
            cursor: pointer;
        }
    }
    .select-role-title {
        margin-top: 50px;
        padding-top: 150px;
        h3 {
            margin: 0;
            font-size: 22px;
            color: #171725;
        }
        h6 {
            margin: 10px 0 50px;
            font-size: 14px;
            color: #171725;
            font-weight: normal;
        }
    }

    .organization-list {
        padding: 0 30px;
        display: flex;
        // justify-content: space-evenly; //虽然能平均分配，但是有兼容性问题
        justify-content: space-around;
        flex-wrap: wrap;
        background-color: #f3f3f5;
        .organization-item {
            width: 320px;
            margin: 0 20px 20px;
            // background-color: #fff;
            .organization-name {
                box-sizing: border-box;
                width: 320px;
                height: 155px;
                cursor: pointer;
                // text-align: center;
                // line-height: 155px;
                display: table;
                background: #ffffff;
                box-shadow: 0 10px 49px 0 rgba(0, 0, 0, 0.1);
                border-radius: 20px;
                padding: 10px;
                font-size: 22px;
                letter-spacing: 0.1px;
                .text-container {
                    display: table-cell;
                    vertical-align: middle;
                    // display: inline-block;
                    // line-height: 1.5;
                    // vertical-align: middle;
                }
                &.active {
                    color: #ffffff;
                    background-color: #0062ff;
                }
            }
            .el-checkbox {
                margin-top: 40px;
            }
            // &:nth-child(n + 4) {
            //   margin-top: 20px;
            // }
        }
    }
}
</style>
